import { changesDigitalData } from '@/utils/digitalData';
import { NOT_REAL_MONEY_LIST } from '@/utils/constants/paymentTypes';
import { getLineItemsBasket } from '@/utils/formatters/formattedDigitalDataManager';

const getContactInfo = (orderPropertyValue) => {
  const contactInfo = {};

  const email = orderPropertyValue.find(item => item.code === 'EMAIL')?.value ?? null;
  const phone = orderPropertyValue.find(item => item.code === 'PERSONAL_PHONE')?.value ?? null;
  const firstName = orderPropertyValue.find(item => item.code === 'NAME')?.value || null;
  const lastName = orderPropertyValue.find(item => item.code === 'LAST_NAME')?.value || null;
  const secondName = orderPropertyValue.find(item => item.code === 'SECOND_NAME')?.value || null;

  if (phone) {
    contactInfo.phone = phone;
  }
  if (email) {
    contactInfo.email = email;
  }
  if (firstName) {
    contactInfo.firstName = firstName;
  }
  if (lastName) {
    contactInfo.lastName = lastName;
  }
  if (secondName) {
    contactInfo.secondName = secondName;
  }

  return contactInfo;
};

const getRealPayment = (order) => {
  const orderPayment = order
    ?.orderPayment
    ?.filter(item => item.type === 'orderPayment');

  const [item] = (orderPayment ?? []).filter(el => !NOT_REAL_MONEY_LIST.includes(el.code));

  return item.name ?? '';
};

const getCoupons = order => order
  ?.orderAppliedCoupon
  ?.map(item => item.code) ?? [];

const useTransaction = () => {
  const resetTransaction = () => {
    changesDigitalData(['transaction', {}, 'book24']);
  };

  const setTransaction = (order, { isReturning = false }) => {
    const orderPropertyValue = order?.orderPropertyValue ?? [];

    const isFirstOrder = orderPropertyValue.find(item => item.code === 'IS_FIRST_ORDER')?.value ?? 'Y';

    changesDigitalData(['transaction', {
      cartId: order.cart.id,
      contactInfo: getContactInfo(orderPropertyValue),
      checkoutType: '5-step',
      currency: 'RUB',
      isFirst: isFirstOrder === 'Y',
      isReturning,
      // TODO: перенос
      lineItems: order.cart.cartItem.map(item => getLineItemsBasket(item, {})),
      orderId: order.id,
      orderIndex: order?.orderStats?.orderIndex ?? 1,
      paymentMethod: getRealPayment(order),
      shippingCost: +(order?.orderShipment?.amount ?? 0),
      shippingMethod: order?.orderShipment?.name ?? '',
      subtotal: +order.amount.total,
      total: +order.amount.discounted + +order.amount.delivery,
      voucherDiscount: +order.amount.total - +order.amount.discounted,
      vouchers: getCoupons(order),
      bonusUsed: +order.amount.bonusPaid,
      bonusUsedRub: +order.amount.bonusPaid,
    }, 'book24']);
  };

  return { setTransaction, resetTransaction };
};

export default useTransaction;
